<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-if="this.user.user.roles[0].id == 1" :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('tel70')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="toptj" v-loading="homeLoading">
                <div class="tjitem" >
                    <span>{{$t('tel71')}}</span>
                    <div>
                        <i style="color: red;font-size: 20px;">{{homeTotal.callNum}}</i>
                    </div>
                </div>
                <div class="tjitem">
                    <span>{{$t('re28')}}</span>
                    <div>
                        <i style="color: red;font-size: 20px;">{{homeTotal.recall}}</i>
                    </div>
                </div>
                <div class="tjitem">
                    <span>{{$t('re29')}}</span>
                    <div>
                        <i style="color: red;font-size: 20px;">{{homeTotal.recallRate}}</i>
                    </div>
                </div>
                <div class="tjitem">
                    <span>{{$t('re30')}}</span>
                    <div>
                        <i style="color: red;font-size: 20px;">{{homeTotal.callMoney}}</i>
                    </div>
                </div>
                <div class="tjitem">
                    <span>{{$t('re31')}}</span>
                    <div>
                        <i style="color: red;font-size: 20px;">{{homeTotal.recallMoney}}</i>
                    </div>
                </div>
            </div>
            <div class="search">
                <div class="searchleft">
                    <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                        <el-form-item :label="$t('phone')">
                            <el-input v-model="searchform.phone" @keyup.enter.native="onSubmit" size="small"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('tel85')">
                            <el-select v-model="searchform.idDial" style="width:120px;">
                                <el-option :label="$t('buxian')" :value="null"></el-option>
                                <el-option :label="$t('tel11')" :value="0"></el-option>
                                <el-option :label="$t('tel12')" :value="1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('tel66')">
                            <el-select size="small" v-model="searchform.principalId" filterable :placeholder="$t('qxz')">
                                <el-option :label="$t('qxz')" :value="null"></el-option>
                                <el-option v-for="item in principallist"
                                    :key="item.id"
                                    :label="item.nickName"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('re23')">
                            <el-select size="small" v-model="searchform.iden" multiple filterable :placeholder="$t('qxz')">
                                <el-option :label="$t('re24')" value="0"></el-option>
                                <el-option :label="$t('re25')" value="1"></el-option>
                                <el-option :label="$t('re26')" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="listbox" style="margin-left: -16px;">
                <div class="listright" v-loading="loading">
                    <el-table :data="list" highlight-current-row @current-change="handleCurrentChange"  
                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" >
                        <el-table-column prop="phone" :label="$t('phone')">
                            <template slot-scope="scope">
                                <el-link type="primary" @click="dial(scope.row.phone)">
                                    {{scope.row.phone}}
                                </el-link>
                            </template>
                        </el-table-column>
                        <el-table-column prop="level" :label="$t('createTime')" width="180px">
                            <template slot-scope="scope">
                                {{scope.row.createTime|changedate}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="userName" :label="$t('tel74')"></el-table-column>
                        <el-table-column prop="isDial" :label="$t('tel15')">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.isDial==0" type="primary" size="mini">{{$t('tel11')}}</el-tag>
                                <el-tag v-if="scope.row.isDial==1" type="info" size="mini">{{$t('tel12')}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="stayDay" :label="$t('tel75')"></el-table-column>
                        <el-table-column prop="type" :label="$t('status')"></el-table-column>
                        <el-table-column prop="jobName" :label="$t('operator')" width="170" fixed="right">
                            <template slot-scope="scope">
                                <el-tooltip class="item" effect="dark" :content="$t('tel76')" placement="top">
                                     <el-button size="small" @click="openadd(scope.row)" type="primary" icon="el-icon-phone-outline" circle plain></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="page">
                        <app-page :total="total" :current="pageNo" :pageSize="pageSize"
                            @handleCurrentChange="currentchange" @handleSizeChange="handchange"></app-page>
                    </div>
                </div>
            </div>
        </div>
        <pop-up :title="$t('tel76')" :isshow="showadd" :haveconfirm="true" @close="getclose" @confirm="getconfirm">
            <div slot="box" class="addCss">
                <el-form ref="form" :inline="true" :model="form" :rules="rules" size="small" label-width="120px">
                    <el-form-item :label="$t('beizhu')" prop="remark">
                        <el-input type="textarea" v-model="form.remark" style="width: 107%;"/>
                    </el-form-item>
                    <el-form-item :label="$t('re23')" prop="iden">
                        <el-select v-model="form.iden" multiple :placeholder="$t('qxz')">
                            <el-option :label="$t('re24')"  value="0"></el-option>
                            <el-option :label="$t('re25')" value="1"></el-option>
                            <el-option :label="$t('re26')" value="2"></el-option>
                            <!-- <el-option :label="$t('re27')" value="3"></el-option> -->
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
        </pop-up>
        <pop-up :title="$t('tel16')" :isshow="showadd111" :haveconfirm="true" @close="getclose12" @confirm="getconfirm12">
            <div slot="box">
                <el-form ref="form" :inline="true" :model="form" :rules="rules" size="small">
                    <el-form-item :label="$t('p12')" prop="channel">
                        <el-radio-group v-model="form.channel">
                            <el-radio valeu="1" label="WhatsApp"></el-radio>
                            <el-radio valeu="2" label="Telephone"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
        </pop-up>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                form: {
                    id: null,
                    phone: null,
                    mchOrderNo: null,
                    email: null,
                    userName: null,
                    cantidad: null,
                    days: null,
                    overdueDay: null,
                    expireTime: null,
                    createTime: null,
                    exclusiveLinks:null,
                    stats: null
                },
                homeTotal:{
                    callNum: 0,
                    recall: 0,
                    recallRate: 0,
                    callMoney: 0,
                    recallMoney: 0
                },
                searchform: {
                    blurry: "",
                    idDial: "",
                },
                searchform1: {
                    phone: "",
                },
                defaultProps: {
                    label: "name",
                    isLeaf: 'isLeaf'
                },
                loading: false,
                homeLoading:false,
                showadd: false,
                showadd111: false,
                list: [],
                value1:[],
                searchform:{},
                principallist:[],
                total: 0,
                pageNo: 1,
                pageSize: 10,
                keyword: '',
                user:null,
                status: null,
                loanList:[],
                list1: [],
                orderDeId: null,
                phone: null,
            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.getprincipal()
            this.getHomeTotal()
            this.getList()
        },
        methods: {
            dial(row) {
                this.phone = row
                this.showadd111 = true
            },
            getprincipal() {
                _api.get(apiurl.users, {
                    roleId: 5,
                }).then(res => {
                    this.principallist = res.content
                })
            },
            getconfirm12() {
                if (this.form.channel == "WhatsApp") {
                    _api.get(apiurl.waDial, {
                        phone: this.phone,
                    }).then(res => {
                        window.open('https://wa.me/' + this.phone, '_blank')
                    }).catch(err => {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: err.data.message
                        })
                    })
                } else {
                    _api.get(apiurl.dial, {
                        phone: this.phone,
                        type: 1,
                        iden: 1,
                    }).then(res => {
                        alert(res.message);
                    }).catch(err => {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: err.data.message
                        })
                    })
                }
                this.showadd111 = false
            },
            openadd(row) {
                this.orderDeId = row.id;
                this.showadd = true
                this.form = {
                    id: null,
                    clientName: null,
                    tel: null,
                    callTime: null,
                    concern: null,
                    acceptorTime: null,
                    className: null,
                    remark: null,
                    userName: null,
                    nation: localStorage.getItem("nation"),
                    orderId: row.id,
                    iden: row.iden ? row.iden.split(",").map(String) : [],
                }
            },
            getconfirm() {
                if (this.form.iden != null) {
                    this.form.iden = this.form.iden.join(",")
                }
                _api.post(apiurl.callInfo, this.form)
                .then(res => {
                    this.$notify.success({
                        title: this.$t('success'),
                        message: this.$t('addSuccess')
                    })
                    this.getList()
                    this.showadd = false
                    this.form = {
                        id: null,
                        clientName: null,
                        tel: null,
                        callTime: null,
                        concern: null,
                        acceptorTime: null,
                        className: null,
                        remark: null,
                        iden: null,
                        userName: null,
                        orderId: this.orderDeId
                    }
                }).catch(err => {
                    this.$notify.error({
                        title: this.$t('error'),
                        message: err.data.message
                    })
                })
            },
            getList() {
                this.loading = true
                const ss = null
                if (this.searchform.iden != null) {
                    this.ss = this.searchform.iden.join(",")
                }

                _api.get(apiurl.mytelorder, {
                    page: this.pageNo,
                    size: this.pageSize,
                    phone: this.searchform.phone,
                    principalId: this.searchform.principalId,
                    idDial: this.searchform.idDial,
                    iden: this.ss,
                }).then(res => {
                    this.loading = false
                    this.list = res.data.list
                    this.total = res.data.total
                })
            },
            getHomeTotal(){
                this.homeLoading = true
                _api.get(apiurl.telTotal,{
                    nation:localStorage.getItem("nation"),
                }).then(res=>{
                    this.homeLoading = false
                    this.homeTotal.callNum=res.data.callNum
                    this.homeTotal.recall=res.data.recall
                    this.homeTotal.recallRate=res.data.recallRate
                    this.homeTotal.callMoney=res.data.callMoney
                    this.homeTotal.recallMoney=res.data.recallMoney
                })
            },

            handchange(data) { //分页Size变化
                this.pageSize = data
                this.pageNo = 1
                this.getList()
            },
            currentchange(data) { //当前页变化
                this.pageNo = data
                this.getList()
            },
            onSubmit() {
                this.pageNo = 1
                this.getList()
            },

            getclose() {
                this.$refs.form.resetFields();
                this.showadd = false
            },
            getclose12() {
                this.$refs.form.resetFields();
                this.showadd111 = false
            },
            onSubmit() {
                this.pageNo = 1
                this.getList()
            },
        }
    }
</script>
<style scoped>
    
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .orderdiv{
        display: flex;
        border-style: ridge;
        border-bottom: 1px solid #EBEEF5;
    }

    .listleft {
        width: 50%;
        margin-left: 0.5%;
    }

    body .el-table th.gutter{
        display: table-cell!important;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }
    .formbox{ padding:15px 0; margin-top: 10px;}

    .listrighttop span {
        float: right;
    }
    .toptj{ display: flex; margin:15px 0;}
    .tjitem{ 
        flex: 1; 
        background: #ffffff; 
        cursor: pointer; 
        border: #ebedf0 solid 1px; 
        height: 60px; 
        margin-right: 10px;
        padding: 8px 12px;
        text-align: center;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>